import {
  Card,
  CardHeader,
  CardFooter,
  Pagination,
  PaginationItem,
  PaginationLink,
  Table,
  Container,
  Row,
  Button,
} from "reactstrap";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { FiTrash2 } from "react-icons/fi";

const useInterval = (callback, delay) => {
  const savedCallback = useRef();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    const tick = () => {
      savedCallback.current();
    };
    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
};

const AdjuntosCargados = (props) => {
  const [list1, setList1] = useState([]);
  const urlendpoint =
    "https://inspecciongnvback-dev.azurewebsites.net/api/v1/ObtenerAnexosOrden/" +
    props.OrdenId;

  const fetchData = () => {
    axios({
      auth: {
        username: "admin.icontec@icontec.org",
        password: "quAngEraMuSTerGerEDE",
      },
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      method: "get",
      url: urlendpoint,
    })
      .then((Response) => {
        setList1(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  useInterval(() => {
    fetchData();
  }, 6000);

  const volver = (e) => {
    e.preventDefault();
    window.location.href = "/admin/Ordenes";
  };

  const hayDocumentosCargados = list1.length > 0;

  const handleDelete = (id, archivo) => {
    const confirmDelete = window.confirm(
      "¿Estás seguro de eliminar este anexo?",
    );
    if (!confirmDelete) return;

    fetch(
      `https://inspecciongnvback-dev.azurewebsites.net/api/v1/EliminaAnexo/${id}/${archivo}`,
      {
        method: "DELETE",
      },
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Error eliminando el anexo");
        }
        // Actualizar lista local eliminando el anexo
        setList1((prevList) => prevList.filter((item) => item.id !== id));
      })
      .catch((error) => {
        console.error("Error eliminando el anexo:", error);
        alert("Error eliminando el anexo");
      });
  };

  return (
    <>
      <Container className="mt--7" fluid>
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0">
                <h3 className="mb-0">Anexos</h3>
              </CardHeader>

              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">AnexoId</th>
                    <th scope="col">URL</th>
                    <th scope="col">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {list1.map((item) => (
                    <tr key={item.id}>
                      <td>{item.adjunto}</td>
                      <td>
                        <a
                          href={item.url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Descargar Archivo Anexo
                        </a>
                      </td>
                      <td>
                        <Button
                          color="danger"
                          onClick={() => handleDelete(item.id, item.adjunto)}
                        >
                          <FiTrash2 />
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              <Button
                color="danger"
                onClick={volver}
                disabled={!hayDocumentosCargados}
              >
                Finalizar
              </Button>

              <CardFooter className="py-4">
                <nav aria-label="...">
                  <Pagination className="pagination justify-content-end mb-0">
                    <PaginationItem className="disabled">
                      <PaginationLink
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                        tabIndex="-1"
                      >
                        <i className="fas fa-angle-left" />
                        <span className="sr-only">Previous</span>
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem className="active">
                      <PaginationLink
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                      >
                        1
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem>
                      <PaginationLink
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                      >
                        2 <span className="sr-only">(current)</span>
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem>
                      <PaginationLink
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                      >
                        3
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem>
                      <PaginationLink
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                      >
                        <i className="fas fa-angle-right" />
                        <span className="sr-only">Next</span>
                      </PaginationLink>
                    </PaginationItem>
                  </Pagination>
                </nav>
              </CardFooter>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default AdjuntosCargados;
